// @flow
import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {debounce,isEmpty,uniqBy,join} from 'lodash'
import Select from 'react-select'
import I18n from 'I18n'
import {NotificationManager} from 'modules/Common/components/Notification'

import Modal from '../Modal'
import 'react-select/dist/react-select.css'
import styles from './AddAMModal.module.scss'
import errorCodeHandle from 'modules/Common/utils/errorCodeHandle'

import type {AMNewDetail} from 'modules/Admin/types'
import type {Props as ParentProps} from './AdminAMList'
import {getRolesList} from '../../actions'
import {getListAccountManagers} from '../../../../api/admin'

export type Props = {
  isShow: boolean,
  handleClose: () => void,
  handleClickButton: Function,
  error?: any,
  companyId?: string,
  companyName?: string,
  isLoadingCompaniesSuggestion: boolean,
  companiesSuggestion: $PropertyType<ParentProps, 'companiesSuggestion'>,
  getCompaniesSuggestion: $PropertyType<ParentProps, 'getCompaniesSuggestion'>,
  getRolesList: Function,
  roleList: $PropertyType<ParentProps, 'roleList'>
};

type State = {
  name: string,
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: string,
  company: string,
  temporaryPassword: string,
  step: string,
  temporaryName: string,
  roleId: string,
  allowAddRole: boolean
};

const I18nLocal = I18n.admin

const stepConstants = {
  inputForm: 'INPUT FORM',
  success: 'SUCCESS'
}

export class AddAMModal extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      company: props.companyId || '',
      temporaryPassword: '',
      step: stepConstants.inputForm,
      temporaryName: '',
      roleId: '',
      allowAddRole: false
    }
  }

  componentDidMount() {
    this.props.getRolesList('ADMINISTRATIVE')
    if (this.props.companyId) {
      this.checkAllowAddRole(this.props.companyId)
    }
  }

  afterOpen = () => {}

  componentWillReceiveProps(nextProps: Props) {
    if (!this.props.companyId && nextProps.companyId) {
      this.setState({
        company: nextProps.companyId || ''
      })
      this.checkAllowAddRole(nextProps.companyId)
    }
  }

  componentDidUpdate(prevProps, prevState: State) {
    const {company} = this.state
    if (company && company !== prevState.company) {
      this.checkAllowAddRole(company)
    }
  }

  checkAllowAddRole = (companyId: string) => {
    this.setState({
      roleId: '',
      allowAddRole: false
    })

    // only allow add role in the first AM
    getListAccountManagers(1,1, undefined, companyId).then(rs => {
      if (rs && rs.records) {
        this.setState({
          allowAddRole: !rs.records.length
        })
      }
    })
  }

  renderHeader = () => {
    if (this.state.step === stepConstants.inputForm) {
      return <span>{I18nLocal.addAccountManager}</span>
    } else {
      return null
    }
  }

  handleSaveBtnClicked = () => {
    const detail: AMNewDetail = {
      user: {
        companyId: this.state.company,
        name: this.state.name,
        persona: {
          email: this.state.email,
          mobilePhoneNumber: this.state.phoneNumber,
          officePhoneNumber: this.state.phoneNumber,
          firstName: this.state.firstName,
          lastName: this.state.lastName
        },
        platformRoles: {
          roleAssignments: [
            {
              roleId: this.state.roleId,
              conditions: [],
              matchingApproach: 'AND'
            }
          ],
          inheritanceStoppers: {}
        },
        roles: ['EXPERT']
      },
      password: this.state.temporaryPassword
    }
    this.props.handleClickButton(detail).then(() => {
      const error = this.props.error
      if (!error) {
        this.setState({
          step: stepConstants.success,
          name: '',
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          company: '',
          temporaryPassword: '',
          temporaryName: detail.user.name
        })
      } else {
        const errorDetailMessage = join(error.details, '. ')
        NotificationManager.error(errorDetailMessage || errorCodeHandle(error.code, error.message))
      }
    })
  }

  hanldeChange = (value: string, key: string) => {
    let state = {...this.state}
    state[key] = value
    this.setState(state)
  }

  checkIsNotHaveEmptyField = () => {
    const requireKeys = [
      'name',
      'firstName',
      'lastName',
      'email',
      'phoneNumber',
      'company',
      'temporaryPassword'
    ]

    if (this.state.allowAddRole) {
      requireKeys.push('roleId')
    }

    return requireKeys.every(key => {
      return this.state[key] !== ''
    })
  }

  calculateDataToRender = () => {
    let listSuggestions = []

    if (!isEmpty(this.props.companiesSuggestion)) {
      listSuggestions = this.props.companiesSuggestion.map(item => {
        return {value: item.id, label: item.fullName}
      })
    }

    let listSuggestionsWithFilledCompany = this.props.companyId
      ? [
        ...listSuggestions,
        {
          value: this.props.companyId,
          label: this.props.companyName
        }
      ]
      : listSuggestions
    listSuggestionsWithFilledCompany = uniqBy(listSuggestionsWithFilledCompany, 'value')
    return listSuggestionsWithFilledCompany
  }

  debounceGetCompaniesSuggestion = debounce((value: string) => {
    if (value !== null && value !== '') {
      this.props.getCompaniesSuggestion(value)
    }
  }, 200)

  renderBodyStepInput = () => {
    const checkIsNotHaveEmptyField = this.checkIsNotHaveEmptyField()
    const listSuggestions = this.calculateDataToRender()

    return (
      <div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.username}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.username}
              value={this.state.name}
              onChange={e => {
                this.hanldeChange(e.target.value, 'name')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.firstName}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.firstName}
              value={this.state.firstName}
              onChange={e => {
                this.hanldeChange(e.target.value, 'firstName')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.lastName}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.lastName}
              value={this.state.lastName}
              onChange={e => {
                this.hanldeChange(e.target.value, 'lastName')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.email}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.email}
              value={this.state.email}
              onChange={e => {
                this.hanldeChange(e.target.value, 'email')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.phoneNumber}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.phoneNumber}
              value={this.state.phoneNumber}
              onChange={e => {
                e.target.value = e.target.value.replace(/\D/g, '')
                this.hanldeChange(e.target.value, 'phoneNumber')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.company}</span>
            <Select
              clearable={false}
              className={styles['field-input']}
              value={this.state.company}
              placeholder={I18nLocal.company}
              options={listSuggestions}
              isLoading={this.props.isLoadingCompaniesSuggestion}
              onInputChange={this.debounceGetCompaniesSuggestion}
              onChange={e => {
                if (e) {
                  this.hanldeChange(e.value, 'company')
                }
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.temporaryPassword}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.temporaryPassword}
              value={this.state.temporaryPassword}
              onChange={e => {
                this.hanldeChange(e.target.value, 'temporaryPassword')
              }}
            />
          </div>

          {this.state.allowAddRole && <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.role}</span>
            <Select
              clearable={false}
              className={`${styles['field-input']} ${styles['select-input']}`}
              value={this.state.roleId}
              placeholder={I18nLocal.selectRole}
              options={(this.props.roleList || []).map(item => {
                return {value: item.id, label: item.name}
              })}
              onChange={e => {
                if (e) {
                  this.hanldeChange(e.value, 'roleId')
                }
              }}
            />
          </div>}
        </div>
        <hr />
        <div className={styles.buttons}>
          <div onClick={this.props.handleClose} className={`${styles.button} ${styles.red}`}>
            {I18nLocal.cancel}
          </div>
          <div
            onClick={() => {
              checkIsNotHaveEmptyField && this.handleSaveBtnClicked()
            }}
            className={`${styles.button} ${!checkIsNotHaveEmptyField ? styles.inactive : ''}`}>
            {I18nLocal.save}
          </div>
        </div>
      </div>
    )
  }

  handleCloseSuccessStep = () => {
    const {companyId,handleClose} = this.props
    this.setState({
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      company: companyId || '',
      temporaryPassword: '',
      step: stepConstants.inputForm,
      temporaryName: '',
      roleId: '',
      allowAddRole: false
    })
    handleClose()
  }

  renderBodyStepSuccess = () => {
    return (
      <div className={styles['success-form']}>
        <div className={styles['title']}>{I18nLocal.inviteSent}</div>
        <span className={styles.inviteMessage}>
          {I18nLocal.inviteMessage} <span className={styles.name}>{this.state.temporaryName}</span>
        </span>
        <div onClick={this.handleCloseSuccessStep} className={styles.button}>
          {I18nLocal.done}
        </div>
      </div>
    )
  }

  render() {
    return (
      <Modal
        handleClose={this.props.handleClose}
        isShow={this.props.isShow}
        renderHeader={() => {
          return this.renderHeader()
        }}
        renderBody={() => {
          return this.state.step === stepConstants.inputForm ? this.renderBodyStepInput() : this.renderBodyStepSuccess()
        }}
        afterOpen={this.afterOpen}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    roleList: state.admin.roleList
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getRolesList
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AddAMModal)
